import React from 'react'
import Qualitydownloadfile from '../../components/qualityreportcomponents/Qualitydownloadfile'


function  Qualitydownload({renderPageContent}) {
    return (
        <>
                        <Qualitydownloadfile renderPageContent={renderPageContent}/>
        </>
    )
}

export default  Qualitydownload
